export default __webpack_public_path__ + "static/media/click1.d501c379.ogg";